<template>
	<div>
		<v-layout row wrap>
			<v-flex xs6 md4 d-flex class="px-1 col-without-label">
				<v-flex
					d-flex align-end
					v-if="showEditButton && index === 0"	
				>
					<div
						class="edit-button-reservation"
						@click.stop="editReservation"
					>
						<v-icon>edit</v-icon>
					</div>
				</v-flex>


				<v-flex
					d-flex align-end xs10 md9
					:class="[
						showEditButton && index !== 0 ? 'ml12' : null,
						!showEditButton && index === 0 ? 'md10' : null,
					]"
				>
				<v-flex
					xs7 px-0 py-0
					:class="[
						showEditButton && index !== 0 ? 'md7' : null,
					]"
					>
						<select-date
							class="xs6"
							placeholder="Fecha de inicio"
							icon="event"
							:append-icon="arrowIconStart"
							:allowed-dates="(date) => isAfterMethod(date, subDaysMethod(new Date(), 2))"
							v-model="booking.checkIn"
							@input="loadRate(booking)"
						/>
					</v-flex>
					<v-flex
					px-0 py-0
					:class="[showEditButton ? 'md5' : 'w39']"
					>
						<select-date
							class="xs6"
							placeholder="Fecha de fin"
							:append-icon="arrowIconEnd"
							:disabled="endDateDisabled(booking, prePayment)"
							:allowed-dates="(date) => isAfterMethod(date, booking.checkIn)"
							v-model="booking.checkOut"
							@input="loadRate(booking)"
						/>
					</v-flex>
				</v-flex>
				<v-flex xs2>
					<img
						class="number-nights"
						:src="`${$imageS3}/clerkinn/nights-icon.svg`"
						alt="">
					<span class="number-nights">
						{{ booking.numberNights }}
					</span>
				</v-flex>
			</v-flex>
			<v-flex xs6 md2 d-flex align-end>
				<select-button
					label-text="Habitación"
					item-text="name"
					item-value="id"
					:disabled="disabledTypeRooms(booking, prePayment)"
					:items="roomsType"
					v-model="booking.entityId"
					@input="loadFreeRooms(booking)"
				/>
				<select-button
					item-text="codeRoom"
					item-value="id"
					:disabled="disabledRooms(booking, prePayment, numberRooms)"
					:items="numberRooms"
					v-model="booking.idRoom"
					@input="loadRate(booking)"
				/>
			</v-flex>
			<v-flex
				xs6 md2 d-flex align-end
				class="col-without-label"
				v-if="index === 0"
			>
				<v-flex xs9 px-0>
					<v-text-field
						class="input-regular input-label"
						hide-details
						readonly
						value="# Huéspedes">
					</v-text-field>
				</v-flex>
				<v-flex xs3 px-0>
					<v-text-field
						class="input-regular input-label"
						hide-details
						readonly
						:value="booking.maxQuantity">
					</v-text-field>
				</v-flex>
			</v-flex>
			<v-flex
				xs6 md1 pr-0 d-flex align-end
				v-if="index === 0"
			>
				<v-flex xs6 py-0>
					<input-text
						type="number"
						label-text="Adultos"
						:disabled="disabledAdults(booking, prePayment)"
						v-model.number="booking.adults"
						@blur="loadRate(booking, true)"
					/>
				</v-flex>
				<v-flex xs6 py-0>
					<input-text
						type="number"
						label-text="Niños"
						:disabled="disabledAdults(booking, prePayment)"
						v-model.number="booking.childs"
						@blur="loadRate(booking, true)"
					/>
				</v-flex>
			</v-flex>
			<v-flex
				xs6 md2 pl-2 d-flex align-end
				:class="[ index !== 0 ? 'offset-xs3' : null]"
			>
				<select-button
					item-text="code"
					item-value="code"
					:items="newCurrencies"
					:disabled="prePayment"
					v-model="booking.currency"
				/>
				<input-text
					class="width-input-night"
					label-text="x Noche"
					:disabled="disabledRate(booking, prePayment)"
					v-model="booking.rate"
					@input="totalByBooking(booking)"
				/>
			</v-flex>
			<v-flex xs6 md1 d-flex align-end>
				<input-text
					readonly
					class="input-regular input-total"
					label-text="Total"
					:value="booking.total | round"
				/>
			</v-flex>
			<v-flex d-flex align-end>
				<v-btn
					class="red--text btn-option"
					icon
					v-if="multipleBookings"
					@click="deleteBooking(index)">
					<v-icon>close</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
import { differenceInDays, subDays } from 'date-fns';
import selectDate from '@/clerkinn/shared/select-date';
import selectButton from '@/clerkinn/shared/select-button';
import inputText from '@/clerkinn/shared/input-text';
import { round } from '@/shared/filters';

function arrowIconStart() {
	const arrow = this.menuStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return	arrow;
}

function arrowIconEnd() {
	const arrowEnd = this.menuEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowEnd;
}

function created() {
	this.newCurrencies = [...this.currencies];
	if (this.typeRooms.length > 1) {
		this.roomsType = [...this.typeRooms];
	}
}

function typeRooms(newValue) {
	this.roomsType = [...newValue];
}

function rooms(newValue) {
	this.numberRooms = [...newValue];
}

function endDateDisabled({ checkIn }, prePayment) {
	return !checkIn || prePayment;
}

function disabledTypeRooms({ checkOut }, prePayment) {
	return !checkOut || prePayment;
}

function disabledRooms({ entityId }, prePayment, quantityRooms) {
	const roomsEmpty = quantityRooms.length === 0;
	return !entityId || prePayment || roomsEmpty;
}

function loadFreeRooms(booking) {
	this.$emit('load-free-rooms', booking);
}

function loadRate(bookings, loadService) {
	this.$emit('load-rate', { bookings, loadService });
}

function disabledAdults({ entityId }, prePayment) {
	return !entityId || prePayment;
}

function totalByBooking(booking) {
	this.$emit('total-by-booking', booking);
}

function disabledRate({ adults }, prePayment) {
	return !adults || prePayment;
}

function deleteBooking(index) {
	this.$emit('delete-booking', index);
}

function isAfterMethod(date, dateToCompare) {
	return differenceInDays(date, dateToCompare) > 0;
}

function subDaysMethod(date, days) {
	return subDays(date, days);
}

function editReservation() {
	this.$emit('edit-reservations', true);
}

function showEditButton() {
	return !!this.codeBooking;
}

function data() {
	return {
		menuStart: false,
		menuEnd: false,
		newCurrencies: [],
		numberRooms: [],
		roomsType: [],
	};
}

export default {
	name: 'rooms-component',
	components: {
		selectButton,
		selectDate,
		inputText,
	},
	computed: {
		arrowIconEnd,
		arrowIconStart,
		showEditButton,
	},
	created,
	data,
	filters: {
		round,
	},
	methods: {
		deleteBooking,
		disabledAdults,
		disabledRate,
		disabledRooms,
		disabledTypeRooms,
		editReservation,
		endDateDisabled,
		isAfterMethod,
		loadFreeRooms,
		loadRate,
		totalByBooking,
		subDaysMethod,
	},
	props: {
		booking: {
			default: () => {},
			type: Object,
		},
		codeBooking: {
			default: false,
			type: Boolean,
		},
		currencies: {
			deafult: () => [],
			type: Array,
		},
		idSubsidiary: {
			default: 0,
			type: [Number, String],
		},
		index: {
			default: null,
			type: Number,
		},
		multipleBookings: {
			default: false,
			type: Boolean,
		},
		prePayment: {
			default: false,
			type: Boolean,
		},
		rooms: {
			deafult: () => [],
			type: Array,
		},
		typeRooms: {
			deafult: () => [],
			type: Array,
		},
	},
	watch: {
		rooms,
		typeRooms,
	},
};
</script>
<style lang="scss" scoped>
.col-without-label {
	padding-bottom: 0px !important;
	padding-top: 25.4px !important;
}
.width-init-date {
	max-width: 150px;
}

.width-end-date {
	max-width: 125px;
}

.width-input-night {
	max-width: 50%;
}

.input-total {
	max-width: 75px;
}

.edit-button-reservation {
	align-items: center;
	background-color: white;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.18);
	cursor: pointer;
	display: flex;
	height: 40px;
	justify-content: center;
	width: 40px;
}

.edit-button-reservation:active {
	transform: scale(0.95);
}

.edit-button-reservation:hover {
	background-color: map-get($colors, button-planning);
	color: white;
}

.w39 {
	width: 39%;
}

.ml12 {
	margin-left: 12%;
}

.border-right {
	border-right: 1px solid map-get($colors, e-bg-icon);
}
</style>




// WEBPACK FOOTER //
// rooms-component.vue?875506c0